import {
  type ApiTableCommandFactory,
  advancedFilterInitialState,
} from 'components/ApiTable/model/ApiTableModel';
import { initializeSimpleFilters } from 'components/ApiTable/model/commands/initializeSimpleFilters';
import { reloadTableData } from 'components/ApiTable/model/commands/reloadTableData';
import { setFilters } from 'components/ApiTable/model/commands/setFilters';

/**
 * Handle stuff that should be restored with Table's "restore settings" UI action
 */
export const restoreSettings: ApiTableCommandFactory =
  (cmdContext, dispatch) => () => {
    const state = cmdContext.getState();
    const shouldReload = state.sort || Object.keys(state.filters).length > 0;

    // purge filter form states, active filters and sorting
    dispatch(initializeSimpleFilters, { initialFilters: {} });
    cmdContext.updateState((draft) => {
      draft.advancedFilter = advancedFilterInitialState;
      draft.sort = undefined;
    });
    dispatch(setFilters, { filters: {}, origin: 'empty' });

    // reload if filtering or sorting was applied before
    if (shouldReload) {
      dispatch(reloadTableData);
    }
  };
